/**
 * Bob Laadt Op — bob-product-tabs (productinformatie in tabs).
 * Bron: werkbestanden/paginas/product-detailv2.html r. 2365–2376: klik op een tab
 * zet aria-selected + tabindex en toont het bijbehorende panel.
 * Toegevoegd t.o.v. het ontwerp: pijltjestoetsen / Home / End (WAI-ARIA tabs) en in de
 * theme editor opent het selecteren van een block het tab (en accordeon-item) waar het in staat.
 */
class BobProductTabs extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    const { signal } = this.abort;

    /** @type {HTMLButtonElement[]} */
    this.tabs = Array.from(this.querySelectorAll('.pdp-tab'));
    /** @type {HTMLElement[]} */
    this.panels = Array.from(this.querySelectorAll('.pdp-tabpanel'));
    if (!this.tabs.length) return;

    this.tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => this.select(tab), { signal });
      tab.addEventListener(
        'keydown',
        (event) => {
          let next = -1;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (i + 1) % this.tabs.length;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (i - 1 + this.tabs.length) % this.tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          if (next < 0) return;
          event.preventDefault();
          this.select(this.tabs[next]);
          this.tabs[next].focus();
        },
        { signal }
      );
    });

    /* Theme editor: block gekozen in de zijbalk → tab openen waar het block in staat */
    this.addEventListener(
      'shopify:block:select',
      (event) => {
        const target = /** @type {HTMLElement} */ (event.target);
        const panel = target.closest('.pdp-tabpanel');
        const tab = panel && this.tabs.find((t) => t.dataset.tab === panel.dataset.panel);
        if (tab) this.select(tab);
        if (target instanceof HTMLDetailsElement) target.open = true;
      },
      { signal }
    );
  }

  disconnectedCallback() {
    this.abort?.abort();
  }

  /** @param {HTMLButtonElement} tab */
  select(tab) {
    this.tabs.forEach((t) => {
      const active = t === tab;
      t.setAttribute('aria-selected', String(active));
      t.tabIndex = active ? 0 : -1;
    });
    this.panels.forEach((panel) => {
      panel.hidden = panel.dataset.panel !== tab.dataset.tab;
    });
  }
}

if (!customElements.get('bob-product-tabs')) customElements.define('bob-product-tabs', BobProductTabs);
